import { useEffect, useState } from 'react';
import pageService from '../../services/home/home.service';
import { DateTime } from 'luxon';

function Home() {

  const [persistence, setPersistence] = useState<{ username: string, password: string }>({ username: '', password: '' });

  const doWork = async () => {
    const nowCheck = DateTime.utc().toMillis() - 2000;
    await pageService.login(persistence.username, persistence.password)
      .then(response => {
        const timestamp = DateTime.fromISO(response.data.timestamp).toMillis();

        console.log('timestamp:', timestamp);
        console.log('nowCheck:', nowCheck);
        console.log('timestamp > nowCheckParsed:', timestamp > nowCheck);

        if (response.status === 200 && timestamp > 0 && timestamp > nowCheck) {
          localStorage.setItem('token', response.data.token);
          window.location.href = "/summary";

          let authHeader = 'Basic ' + btoa(`${persistence.username}:${persistence.password}`);
          localStorage.setItem('basicAuthHeader', authHeader);
        }
      });
  };

  const handleInput = async (e: any, name: string) => {
    let value = e?.target?.value || '';
    setPersistence(current => ({ ...current, [name]: value }));
  };

  const handleKeyUp = async (e: any) => {
    const key = (e.key || e.keyCode).toString().toLowerCase();
    if (key === '13' || key === 'enter' || key === 'return') {
      await doWork();
    }
  };

  useEffect(() => {
    console.log('initializing...', new Date());
    const check = localStorage.getItem('token');
    if (check) {
      localStorage.removeItem('token');
      localStorage.removeItem('basicAuthToke');
      window.location.reload();
    }
  }, []);

  return (<div>
    <h1>Login</h1>
    <div className='row'>
      <div className='col-12' style={{ textAlign: 'center' }}>Username: <input type="text" onInput={(e) => handleInput(e, 'username')} onKeyUp={(e) => handleKeyUp(e)} /></div>
    </div>

    <div className='row'>
      <div className='col-12' style={{ textAlign: 'center' }}>Password: <input type="password" onInput={(e) => handleInput(e, 'password')} onKeyUp={(e) => handleKeyUp(e)} /></div>
    </div>

    <div className='row mt-3'>
      <div className='col-12' style={{ textAlign: 'center' }}><button className='btn btn-primary' onClick={() => doWork()}>Login</button></div>
    </div>
  </div>);
};

export default Home;
